import type { SeatState } from '@okn/shared';
import { STATE_FILL_VAR, STATE_LABEL_TR } from './seat-state.ts';

const VISIBLE_STATES: SeatState[] = [
  'available',
  'reserved',
  'sold',
  'held',
  'protocol',
  'closed',
];

export function Legend() {
  return (
    <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
      {VISIBLE_STATES.map((s) => (
        <li
          key={s}
          className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-text-muted"
        >
          <span
            aria-hidden
            className="inline-block h-2.5 w-2.5 rounded-[2px] border border-border-strong"
            style={{ background: STATE_FILL_VAR[s] }}
          />
          {STATE_LABEL_TR[s]}
        </li>
      ))}
      <li className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-text-muted">
        <span
          aria-hidden
          className="inline-block h-2.5 w-2.5 rounded-[2px] border border-border-strong"
          style={{ background: 'var(--seat-zone)' }}
        />
        Özel alan (maks 3)
      </li>
    </ul>
  );
}
